//TODO DPH: Initialize as logit.classes.EditableDataContainer = function.... Its IIFE nature needs extra handling when the namespace hasn't been initialized yet
var EditableDataContainer = new (function () {
    var storage = [];

    this.addTable = function (tableEditableData) {
        PubSub.publish('edc/addTable', tableEditableData);
        storage[tableEditableData.tableId] = tableEditableData.tableEditableItems;
    };

    this.addItem = function (tableEditableItem) {
        PubSub.publish('edc/addItem', tableEditableItem);

        if (storage.hasOwnProperty(tableEditableItem.tableId) === false) {
            storage[tableEditableItem.tableId] = [];
        }

        var existingItemIndex = getExistingItemIndex(tableEditableItem.tableId, tableEditableItem.key);
        if (existingItemIndex == -1) {
            storage[tableEditableItem.tableId].push(tableEditableItem);
        } else {
            storage[tableEditableItem.tableId][existingItemIndex] = tableEditableItem;
        }
    };

    this.updateItem = function (tableEditableItem) {
        PubSub.publish('edc/updateItem', tableEditableItem);

        if (storage.hasOwnProperty(tableEditableItem.tableId) === false) {
            storage[tableEditableItem.tableId] = [];
        }

        var existingItemIndex = getExistingItemIndex(tableEditableItem.tableId, tableEditableItem.key);
        if (existingItemIndex != -1) {
            storage[tableEditableItem.tableId][existingItemIndex] = tableEditableItem;
        } else {
            this.addItem(tableEditableItem);
        }
    };

    function getExistingItemIndex(tableId, itemKey) {
        if (typeof (storage[tableId]) === 'undefined') {
            return -1;
        }

        for (var i = 0; i < storage[tableId].length; i++) {
            var item = storage[tableId][i];
            if (item.key == itemKey) {
                return i;
            }
        }

        return -1;
    }

    this.getTable = function (tableId) {
        PubSub.publish('edc/getTable', storage);
        return storage[tableId];
    };

    this.clearTable = function (tableId) {
        delete storage[tableId]; // Experimental!
        PubSub.publish('edc/clearData', storage);
    };

    this.clearItem = function (tableId, pk, columnIndex) {
        var itemIndex = getExistingItemIndex(tableId, getKey(tableId, pk, columnIndex));

        if (itemIndex === -1) {
            return;
        }

        delete storage[tableId].splice(itemIndex, 1);

        PubSub.publish('edc/clearItem', storage);
    };

    this.getItem = function (tableId, pk, columnIndex) {

        var itemIndex = getExistingItemIndex(getKey(tableId, pk, columnIndex));


        if (itemIndex === -1) {
            return;
        }

        PubSub.publish('edc/getItem', storage);
        return storage[tableId][itemIndex];
    };

    function getKey(tableId, pk, columnIndex) {
        return [tableId, pk, columnIndex].join('_');
    }

})();


export default EditableDataContainer;